export const applicationDateList = [
    {name: 'Select Application Date', id: ''},
    {name: '3 Days', id: 3},
    {name: '7 Days', id: 7},
    {name: '15 Days', id: 15},
    {name: '30 Days', id: 30}
]
    